export default __webpack_public_path__ + "static/media/fig-17-shear-inclined-ps.1913d275.png";